/// <amd-module name="Dashboards/ConfigHost/HostImplementations/ModernConfigHost" />
import { ConfigProps, LoadedEventInfo } from "Dashboards/WidgetContracts/Internal/ConfigProps";
import { ContributionComponentProps } from "Dashboards/WidgetContracts/Internal/WidgetContributionTypes";
import * as React from "react";
import { IVssComponentContext, IVssComponentProperties, VssComponent, WrappedComponent } from "VSS/Platform/Layout";

/** Contribution backed information about what is supported in the widget Configuration. */

export interface ModernConfigHostProps extends ConfigProps, IVssComponentProperties {
    configContributionComponentProps: ContributionComponentProps;
}

interface ModernConfigHostState {
    isLoading: boolean;
}

/** The Modern Config host simply deals with rendering of New Platform Configs. */
export class ModernConfigHost extends VssComponent<ModernConfigHostProps, ModernConfigHostState> {
    constructor(props: ModernConfigHostProps, context: IVssComponentContext) {
        super(props, context);

        this.state = {
            isLoading: true
        };
    }

    public render(): JSX.Element {
        return (
            <div className="modern-config-host">
                {
                    <ModernConfigHostRenderer
                        {...this.props}
                        parentProps={{
                            onConfigLoaded: this.onConfigLoaded,
                            onUpdate: this.props.parentProps.onUpdate,
                            onValidationResponse: this.props.parentProps.onValidationResponse
                        }}
                    />
                }
            </div>
        );
    }

    private onConfigLoaded = (loadedEventInfo?: LoadedEventInfo): void => {
        if (this.state.isLoading) {
            this.setState({ isLoading: false });

            // relay event up the stack.
            this.props.parentProps.onConfigLoaded(loadedEventInfo);
        }
    };
}

export interface ModernConfigProps extends ConfigProps, IVssComponentProperties {
    /**
     * Props for rendering New plat widget components
     */
    configContributionComponentProps: ContributionComponentProps;
}

/** Provides an intermediate layer for preventing re-renders of children */
class ModernConfigHostRenderer extends VssComponent<ModernConfigProps> {
    public render(): JSX.Element {
        return (
            <WrappedComponent
                className={this.props.className}
                wrappedType={this.props.configContributionComponentProps.componentType}
                dependencies={this.props.configContributionComponentProps.includes}
                wrappedProps={this.props}
            />
        );
    }
}
